AOS.init();

document.addEventListener('DOMContentLoaded', () => {
  const uwb = new UWB({
    toolSmoothScroll: {
      offsetSelector: '',
    },
  });

  const startFire = document.documentElement.clientHeight / 2;
  UWX.ScrollActionReferPosition('.pagetop', startFire);
  UWX.ScrollActionReferPosition('.page_header', startFire, {
    activeClass: 'fixed',
  });

  UWX.MenuActivate('.menu_btn', '.header_nav', 'active');
  let navlist = Array.from(document.querySelectorAll('.header_nav a'));
  navlist.forEach(item => {
    item.addEventListener('click', () => {
      document.querySelector('.menu_btn').classList.remove('active');
      document.querySelector('.header_nav').classList.remove('active');
    });
  });

  let circles = ['.circle_01', '.circle_02', '.circle_03', '.circle_04', '.circle_05']
  for (let i = 0; i < circles.length; i++) {
    setTimeout(() => {
      $(circles[i]).addClass('scale-in');
    }, 2000 + (100 * i));
  }

});

$(window).on('load', () => {
  $('.loading').delay(1000).fadeOut(500);
  $('.container').delay(1500).addClass('visible');
});
